import { useSelector } from "../store"

export function isAdmin() {
  const user = useSelector(({ user }) => user)
  if (user?.permissions) {
    if (user.permissions.find((p) => p.name === "Dashboard.Admin")) return true
  }
  return false
}
